
export default {
  namespaced: true,
  state: {
    applyActive: null
  },

  getters: {
    applyActive: (state) => {
      return state.applyActive
    }
  },
  mutations: {
    setApplyActive(state, applyActive) {
      state.applyActive = applyActive
    },
    clearApplyActive(state) {
      state.applyActive = null
    }
  }
}
